import React from 'react';
import { Stack } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { NextPrevButton } from 'Components/NextPrevButton';
import { useDictionary, useIsDesktop } from 'Hooks';

interface IActionButtons {
  handleBack: () => void;
  handleSubmit: () => void;
}

export const ActionButtons: React.FC<IActionButtons> = ({
  handleBack,
  handleSubmit,
}) => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.UniversalRequest);
  const isDesktop = useIsDesktop();

  return (
    <Stack
      direction={isDesktop ? 'row' : 'column-reverse'}
      justifyContent='space-between'
      alignItems='center'
      gap={isDesktop ? '24px' : '12px'}
      mt={isDesktop ? '40px' : '0px'}
      mb={isDesktop ? '80px' : '0px'}
    >
      <NextPrevButton
        callback={handleBack}
        style={{
          button: {
            p: '10px 33px 10px 31px',
            width: '283px',
            bgcolor: isDesktop ? undefined : 'transparent',
            border: isDesktop ? undefined : 'none',
            boxShadow: 'none',
          },
          text: {
            fontWeight: isDesktop ? undefined : '400',
          },
        }}
        text={dictionary.uploadFile.back}
      />

      <NextPrevButton
        callback={handleSubmit}
        style={{ button: { p: '10px 33px 10px 31px', width: '357px' } }}
        text={dictionary.uploadFile.submitApply}
        isNext
        isBlue
        hideArrowIcon={true}
      />
    </Stack>
  );
};
